import type {OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum} from '@stripe-internal/data-v1/schema/types';
import {absurd} from 'src/utils/absurd';

/**
 * Whether an asset's value is stable (pegged) — e.g. so callers can fetch a
 * single quote for stable assets instead of refreshing on an interval.
 *
 * The exhaustive switch forces any newly added asset code to be classified
 * here at compile time (the `absurd` default stops type-checking otherwise).
 */
export const isStablecoin = (
  assetCode: OpenapiCryptocurrencyPayinsResourceSupportedCurrencyAssetCodeEnum,
): boolean => {
  switch (assetCode) {
    case 'usdc':
    case 'usdt':
    case 'usdg':
    case 'usdp':
    case 'usdsui':
    case 'cash':
    case 'phantom_cash':
      return true;
    case 'btc':
    case 'eth':
    case 'sol':
      return false;
    default:
      return absurd(assetCode);
  }
};
